import BigNumber from 'bignumber.js'

// 加法
export function add() {
  let start = new BigNumber(arguments[0])
  for (const it of [...arguments].slice(1)) {
    start = start.plus(it)
  }
  return start.toNumber()
}

// 减法
export function subtract() {
  let start = new BigNumber(arguments[0])
  for (const it of [...arguments].slice(1)) {
    start = start.minus(it)
  }
  return start.toNumber()
}

// 乘法
export function multiply() {
  let start = new BigNumber(arguments[0])
  for (const it of [...arguments].slice(1)) {
    start = start.multipliedBy(it)
  }
  return start.toNumber()
}

// 除法
export function divide() {
  let start = new BigNumber(arguments[0])
  for (const it of [...arguments].slice(1)) {
    start = start.dividedBy(it)
  }
  return start.toNumber()
}
